import { extractFormulaInput } from '@linkpi/core';

export const extractInput = extractFormulaInput;
